import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  tableMeasurement: {
    "&.loading .ReactVirtualized__Table__row": {
      cursor: "progress",
    },
  },
  tableContract: {
    "&.selected [role='cell']:not(.MuiVirtualizedTable-cell-selected)": {
      backgroundColor: "rgba(0, 0, 0, 0.08)",
    },
    "& .MuiVirtualizedTable-column-quantity": {
      height: 34,
    },
    "& .ReactVirtualized__Table__row:hover .button-edit-description": {
      display: "unset",
    },
  },
  tableSize: {
    width: "calc(100vw - 40px)",
  },
  tableRetractSize: {
    width: "calc(100vw - 288px)",
  },
  tableCell: {
    border: `1px solid ${theme.palette.gray[400]}`,
    borderLeftColor: "transparent",
    borderTopColor: "transparent",
    "&.MuiVirtualizedTable-column-code": {
      backgroundColor: theme.palette.gray[200],
      fontWeight: 500,
    },
    "&.MuiVirtualizedTable-cell-canceled": {
      textDecoration: "line-through",
    },
  },
  tableHeadCell: {
    borderBottom: `1px solid ${theme.palette.gray[400]}`,
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
  },
  stageRow: {
    fontWeight: 500,
    "&.MuiVirtualizedTable-column-descricao": {
      textTransform: "uppercase",
    },
    "&.MuiVirtualizedTable-column-quantity, &.MuiVirtualizedTable-column-currentQuantity":
      {
        "& input": {
          display: "none",
        },
      },
  },
  loading: {
    position: "absolute",
    width: "100%",
    backgroundColor: "rgba(255, 255, 255, 0.6)",
    height: "100%",
    zIndex: 2,
  },
}));

export default useStyles;
